module.exports = __webpack_public_path__ + "static/media/bg-mockup-smartphones.f82c2ede.png";